/**
 * URL utility functions for handling backend API resources
 */

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.saltmarshdigital.com/api';
const API_BASE = API_URL.replace(/\/api$/, ''); // Remove '/api' suffix to get base URL

// Log the API configuration for debugging
console.log('API Configuration:', {
  API_URL, 
  API_BASE
});

/**
 * Ensures a URL is absolute by prefixing the backend base URL if needed
 * 
 * @param url The URL which might be relative
 * @returns An absolute URL
 */
export const ensureAbsoluteUrl = (url: string): string => {
  if (!url) return '';
  
  // If it's already an absolute URL, return it as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it starts with a slash but not double slash
  if (url.startsWith('/') && !url.startsWith('//')) {
    return `${API_BASE}${url}`;
  }
  
  // Otherwise, assume it needs to be joined with the API base URL
  return `${API_BASE}/${url}`;
};

/**
 * Get the absolute video URL for a video resource
 * 
 * @param videoUrl The video URL from the API
 * @returns The absolute URL to the video resource
 */
export const getVideoUrl = (videoUrl?: string): string => {
  if (!videoUrl) return '';
  return ensureAbsoluteUrl(videoUrl);
};

/**
 * Checks if a URL is a relative URL 
 * 
 * @param url The URL to check
 * @returns True if the URL is relative, false if absolute
 */
export const isRelativeUrl = (url?: string): boolean => {
  if (!url) return false;
  return !(url.startsWith('http://') || url.startsWith('https://'));
}; 